import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DataService } from '../data.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  alertSuccess: boolean = false;
  alertError: boolean = false;
  error: String;
  
  constructor( private router: Router, 
               private route: ActivatedRoute,
               private data: DataService) {    
 }

  ngOnInit() {
    const firstParam: string = this.route.snapshot.queryParamMap.get('SucessoRegistoAnterior');
    this.alertSuccess = (firstParam == "true");
    this.alertError = (firstParam == "false");

    if (this.alertSuccess){
      setTimeout(()=>{
        this.alertSuccess = false;
      }, 5000);
    }

    if (this.alertError){
      setTimeout(()=>{
        this.alertError = false;
      }, 5000);
    }
  }

  onSubmit(e) {
    this.data.username = e.target[0].value;
    this.data.userpass = e.target[1].value;

    this.router.navigate(['/utente']);
  }

  closeAlert() {
    this.alertSuccess = false;
    this.alertError = false;
  }
  
}
